// extracted by mini-css-extract-plugin
module.exports = {"modal-title":"style_modal-title__GEM_v"};